import { tv } from '~/utils/tv'

export const inputSelectVariants = tv({
  base: `flex w-full min-w-20 cursor-pointer items-center justify-between gap-2 border-forms-border leading-[0%]
          bg-forms-fill px-4 px-threepulse font-rdmodern text-text-neutral-alternative border-solid border-none
          hover:border-forms-border-filled hover:bg-forms-fill-hovered 
          focus:border-solid focus:border-forms-border-focused focus:border-halfpulse focus:bg-forms-fill-focused focus:outline-none 
          active:border-solid active:border-forms-border-focused active:border-halfpulse active:bg-forms-fill-focused`,
  variants: {
    size: {
      md: 'h-medium rounded-form',
      ml: 'h-mediumlarge rounded-form',
      lg: 'h-large rounded-form',
      xl: 'h-extralarge rounded-largecontainer',
    },
    selected: {
      true: 'border-forms-border-filled border-quarterpulse border-solid bg-forms-fill-filled hover:border-halfpulse hover:bg-forms-fill-filled',
      false: '',
    },
    error: {
      true: `border-forms-border-error border-quarterpulse border-solid hover:border-forms-border-error hover:border-halfpulse
      focus:border-forms-border-error active:border-forms-border-error`,
      false: '',
    },
    disabled: {
      true: `cursor-not-allowed border-forms-border-disabled border-quarterpulse border-solid bg-forms-fill-disabled hover:border-forms-border-disabled
      hover:border-quarterpulse hover:bg-forms-fill-disabled focus:border-forms-border-disabled focus:border-quarterpulse active:border-forms-border-disabled active:border-quarterpulse`,
    },
    readonly: {
      true: `cursor-not-allowed border-forms-border-readonly border-solid border-quarterpulse bg-forms-fill-readonly hover:border-forms-border-readonly
            hover:border-quarterpulse hover:bg-forms-fill-readonly focus:border-forms-border-readonly focus:border-quarterpulse active:border-forms-border-readonly active:border-quarterpulse`,
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export const SelectedVariants = tv({
  base: 'flex w-full items-center justify-start text-left',
  variants: {
    size: {
      md: 'h-medium text-threepulse',
      ml: 'h-mediumlarge text-threeandhalfpulse',
      lg: 'h-large text-threeandhalfpulse',
      xl: 'h-extralarge text-threeandhalfpulse',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
    },
    readonly: {
      true: 'cursor-not-allowed text-text-neutral-readonly',
    },
  },
  defaultVariants: {
    size: 'md',
    disabled: false,
    readonly: false,
    error: false,
  },
})

export const clearAreaVariants = tv({
  base: 'flex',
  variants: {
    size: {
      md: 'p-fourpulse',
      ml: 'p-fivepulse',
      lg: 'p-fivepulse',
      xl: 'p-fivepulse',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export const dropdownVariants = tv({
  base: `z-50 h-auto w-full border bg-forms-fill-filled
    min-w-[var(--radix-trigger-width)] rounded-md p-onepulse`,
  variants: {
    size: {
      md: 'text-sm',
      ml: 'text-base',
      lg: 'text-lg',
      xl: 'text-lg',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
    },
    readonly: {
      true: 'cursor-not-allowed text-text-neutral-readonly',
    },
    margin: {
      true: 'mt-[30px]',
      false: 'mt-[10px]',
    },
  },
  defaultVariants: {
    size: 'md',
    disabled: false,
    readonly: false,
    margin: false,
  },
})

export const optionVariants = tv({
  base: 'cursor-pointer rounded-pill px-4 py-2 outline-none hover:bg-action-fill-neutral-tertiary-hovered',
  variants: {
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
    },
    readonly: {
      true: 'cursor-not-allowed text-text-neutral-readonly',
    },
  },
  defaultVariants: {
    disabled: false,
    readonly: false,
    error: false,
  },
})

export const iconLeftVariants = tv({
  base: 'mr-2 flex-shrink-0',
})
